export default "__VITE_ASSET__CptL7dji__";